interface EmptyStateProps {
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
}

export default function EmptyState({ title, description, actionLabel, onAction }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-20 px-4 bg-background-50 rounded-lg border border-dashed border-background-300">
      <span className="w-16 h-16 rounded-full bg-primary-50 text-primary-500 flex items-center justify-center">
        <i className="ri-emotion-sad-line text-3xl" />
      </span>
      <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">{title}</h3>
      <p className="mt-2 text-sm text-foreground-600 max-w-md">{description}</p>
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-6 px-5 h-10 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5"
        >
          <i className="ri-refresh-line" />
          {actionLabel}
        </button>
      )}
    </div>
  );
}